import React from 'react'
import {getFeConfig, testUpdateDiscountCreatedDate, visualizeLoad} from "../api/api";
import {Button, PageHeader, Modal, Space, notification, Typography, DatePicker} from 'antd'
import TableDataSource from "../utils/TableDataSource";
import {TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {TableFilter} from "./filters/TableFilter";
import {MapToFilter} from "../utils/mappings";
import {Table} from "@q4us-sw/q4us-ui";
import {RedoOutlined, DropboxOutlined} from "@ant-design/icons";
import moment from "moment";

const OrderDiscountItems = (props) => {
    const [source, setSource] = React.useState(new TableDataSource());

    const fetchData = async (values, page = {})=>{
        return await visualizeLoad({
            tableName: 'dashboard_order_discount_breakdown_view',
            orderBy: ['discount_id desc, timestamp_year desc'],
            filter:[{name: 'discount_id', value: props.discount_id}, {name: 'timestamp_year', value: props.timestamp_year}],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    return <Space direction={`vertical`} style={{width: '100%'}}>
        <Table
            fetchConfig={async () => {
                const {data= {}} = await getFeConfig('dashboard_order_discount_breakdown_view')
                const { statusCode, rows = [], fields = [] } = data;
                return { data: { statusCode, rows, fields } };
            }}

            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
            fetchData={async () => {
                return await fetchData()

            }}

            editable={false}
            source={source}
        />
    </Space>
}

const OrderSummary = (props) => {
    const [source, setSource] = React.useState(new TableDataSource());

    const fetchData = async (values, page = {})=>{
        return await visualizeLoad({
            tableName: 'order_info_view_with_s10',
            orderBy: ['id desc, timestamp_year desc'],
            filter:[{name: 'id', value: props.order_id}, {name: 'timestamp_year', value: props.timestamp_year}],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }

    return <Space direction={`vertical`} style={{width: '100%'}}>
        <Table
            fetchConfig={async () => {
                const {data= {}} = await getFeConfig('order_info')
                const { statusCode, rows = [], fields = [] } = data;
                return { data: { statusCode, rows, fields } };
            }}

            scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
            fetchData={async () => {
                return  await fetchData()
            }}

            editable={false}
            source={source}
        />
    </Space>
}
const ModalType = Object.freeze({
    None: 0,
    Summary: 1,
    Discount: 2
})
export const OrderDiscount = (props) => {

    const [source, setSource] = React.useState(new TableDataSource());
    const [refresh, setRefresh] = React.useState(1);
    const [opt,setOpt] = React.useState({type: ModalType.None, id: undefined, timestamp_year:undefined})

    const fetchData = async (values, page = {})=>{
        const filters = MapToFilter(values)
        return await visualizeLoad({
            tableName: 'dashboard_order_discount_view',
            orderBy: ['id desc'],
            filter:[...filters],
            page: { size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }


    const [discountCreatedDate, setDiscountCreatedDate] = React.useState({
        id:'',
        visible:false,
        timestamp: moment().subtract(1, "months")
    });
    return <React.Fragment>
        <PageHeader title={props.title}/>
        <Space direction={`vertical`} style={{width: '100%'}}>
            <div style={{textAlign: 'right', paddingRight: 7,width: '100%'}} >
                <Button style={{width: 150}} icon={<RedoOutlined/>} onClick={()=>setRefresh(refresh+1)}>Refresh</Button>
            </div>
            <TableV2
                key={refresh}
                header={<TableFilter schema={'order_discount_filter'} fetch={fetchData}/>}
                fetchConfig={async () => {
                    const {data= {}} = await getFeConfig('dashboard_order_discount_view')
                    const { statusCode, rows = [], fields = [] } = data;
                    const {REACT_APP_DEMO_MODE = undefined} = process.env;
                    if (REACT_APP_DEMO_MODE) {
                        rows.unshift({
                            name: "id",
                            title: "Test Actions",
                            width: 140,
                            formatter: (row) => {
                                const {id} = row;
                                return <Space>
                                    <Button onClick={()=>{
                                        setDiscountCreatedDate({
                                            id:`${id}`,
                                            visible: true,
                                            timestamp: moment().subtract(1, "months")
                                        })
                                    }}>Update Discount Created Date</Button>
                                </Space>
                            }
                        })
                    }

                    rows.push({
                        dataIndex: "id",
                        title: "Discount Items",
                        width: 120,
                        formatter: (row, index, name, type, formatted, value) => {
                            return <Button key={'btn'} onClick={async () => {
                                setOpt({type: ModalType.Discount, id: row.id, timestamp_year: row.timestamp_year})
                            }}>Items</Button>
                        }
                    })
                    rows.push({
                        dataIndex: "id",
                        title: "Order Summary",
                        width: 120,
                        formatter: (row, index, name, type, formatted, value) => {
                            return <Button key={'btn'} onClick={async () => {
                                setOpt({type: ModalType.Summary, id: row.order_id, timestamp_year: row.timestamp_year})
                            }}>View</Button>
                        }
                    })
                    return { data: { statusCode, rows, fields } };
                }}

                scroll={{y: 'calc(90vh - 40px)', x: 'max-content' }}
                fetchData={async (request) => {
                    return await fetchData(request.options.filter || {}, request.page)
                }}

                editable={false}
                source={source}
            />

            {opt.id && <Modal title={`${opt.type === ModalType.Summary ? "Order View" : "Discount Items"}`}
                              width="80vw"
                              visible={opt.type !== ModalType.None}
                              closable={true}
                              key={opt}
                              footer={null}
                              onCancel={() => {
                                  setOpt({type: ModalType.None, id: undefined})
                              }}
            >
                {opt.type === ModalType.Summary && <OrderSummary order_id={opt.id} timestamp_year={opt.timestamp_year}/>}
                {opt.type === ModalType.Discount && <OrderDiscountItems discount_id={opt.id} timestamp_year={opt.timestamp_year}/>}
            </Modal>}

            <Modal
                centered={true}
                closable={true}
                onCancel={()=>setDiscountCreatedDate({
                    id: '',
                    visible: false,
                    timestamp: moment().subtract(1, "months")
                })}
                visible={discountCreatedDate.visible}
                title={`Mark as Discounted - Discount #${discountCreatedDate.id}`}
                onOk={async ()=>{
                    const {visible, ...args} = discountCreatedDate;
                    const {status} = await testUpdateDiscountCreatedDate({...args});
                    if (status === 200) {
                        notification.success({message: `Discount Created date for Discount-ID ${discountCreatedDate.id} updated`});
                    } else {
                        notification.error({message: `Error updating Discount Created date for Discount-ID ${discountCreatedDate.id}.`});
                    }
                    setDiscountCreatedDate({
                        id:'',
                        visible:false,
                        timestamp: moment().subtract(1, "months")
                    })
                }}
            >
                Note: Use this is for Invoice/Fiscal report testing purposes only.
                <table>
                    <tr style={{paddingBottom: 10}}>
                        <td style={{padding: 12}}><Typography.Text>Discount Created Date</Typography.Text></td>
                        <td style={{padding: 12}}><DatePicker value={discountCreatedDate.timestamp} onChange={(date)=>{
                            setDiscountCreatedDate({...discountCreatedDate, timestamp: date})
                        }}/></td>
                    </tr>
                </table>
            </Modal>
        </Space>


    </React.Fragment>
}